import React, { useState, useEffect } from "react";
import "./postrepairprocess.css";
import { useParams } from "react-router";
import axios from "axios";

// ✅ Backend strict naming layout ke anusar map kiya gaya hai
const initialImages = [
  { id: 1, name: "pre_repair_img_one", displayName: "Image 1", date: "", url: null },
  { id: 2, name: "pre_repair_img_two", displayName: "Image 2", date: "", url: null },
  { id: 3, name: "pre_repair_img_three", displayName: "Image 3", date: "", url: null },
];

const RepairProcess = () => {
  const { claimNumber } = useParams();
  const [images, setImages] = useState(initialImages);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const upload = `${process.env.PUBLIC_URL}/claim-landing/upload.png`;
  const preview = `${process.env.PUBLIC_URL}/preview.png`;
  const repair = `${process.env.PUBLIC_URL}/repairandpostrepair.png`;

  // ✅ AWS S3 extension validation lookup handler
  const tryBlobExtensions = async (baseName) => {
    const extensions = ["jpg", "jpeg", "png"]; // Added png fallback
    for (let ext of extensions) {
      const blobName = `${baseName}.${ext}`;
      try {
        // Router structure check call path
        const response = await axios.post("/check_document_exists", { blobName });
        if (response.data.exists && response.data.url) {
          return { blobName, url: response.data.url };
        }
      } catch (err) {
        console.error(`Error checking ${blobName}:`, err.message);
      }
    }
    return null;
  };

  useEffect(() => {
    const checkImagesExist = async () => {
      const updatedImages = await Promise.all(
        initialImages.map(async (img) => {
          // ✅ Backend string layout format configuration path lookup match
          const baseBlobName = `Pre-repair-images/${claimNumber}_${img.name}`;
          const result = await tryBlobExtensions(baseBlobName);
          if (result) {
            return {
              ...img,
              url: result.url,
              date: new Date().toLocaleString(),
            };
          }
          return img;
        })
      );
      setImages(updatedImages);
    };

    if (claimNumber) {
      checkImagesExist();
    }
  }, [claimNumber]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        const base64String = reader.result; // Dynamic payload block string payload match
        const updatedImages = [...images];
        const currentDateTime = new Date().toLocaleString();
        
        // ✅ Backend target strict whitelist validation variable schema parameters string
        const targetSlotName = images[currentImageIndex].name; // "pre_repair_img_one", etc.
        const contentType = file.type;

        console.log("Uploading to S3 via updated endpoint:", { targetSlotName, contentType });

        // ✅ URL parameters mapping configuration fixed update structure router sequence
        const response = await axios.post("/process_data/ur-img-upload", {
          claimNumber,
          blobName: targetSlotName, // Sends "pre_repair_img_one", etc.
          fileContent: base64String, // Passing with data url safely, backend logic trims dynamically!
          contentType,
        });

        if (response.data.message === "Upload successful") {
          updatedImages[currentImageIndex].url = response.data.url; 
          updatedImages[currentImageIndex].date = currentDateTime;

          setImages(updatedImages);

          // ✅ DB tracker sync flag update trigger
          await axios.post("/update_pre_repair_upload", { claimNumber });

          if (currentImageIndex < images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
          }
        } else {
          throw new Error("Upload failed at backend execution.");
        }
      } catch (error) {
        console.error("Upload to backend failed:", error);
        alert(error.response?.data?.error || "Failed to upload image.");
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div>
      {/* Post Repair Section */}
      <div className="post-repair-card">
        <div className="header">
          <h2>Repair Process</h2>
          <img src={repair} alt="Preview" className="icon-img" style={{ width: "24px", height: "24px" }} />
        </div>

        {/* Mobile Camera Upload */}
        <div className="image-box">
          <label className={`camera-label ${!isMobile ? "disabled" : ""}`}>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              onChange={handleUpload}
              disabled={!isMobile}
            />
            <div className={`camera-trigger ${!isMobile ? "disabled" : ""}`}>
              <img
                src="https://icons.iconarchive.com/icons/iconsmind/outline/512/Camera-2-icon.png"
                alt="camera"
                className="camera-icon"
              />
              <p>Open Camera ({images[currentImageIndex]?.displayName})</p>
            </div>
          </label>
        </div>
      </div>

      {/* Post Repair Images Section */}
      <div className="card">
        <h3 className="title">Repair Process Images</h3>
        <div className="image-list">
          {images.map((image) => (
            <div key={image.id} className="image-card">
              <div className="image-content">
                <div className="text-info">
                  <p className="image-name">{image.displayName}</p>
                  {image.date && <p className="image-date">{image.date}</p>}
                </div>
                <button
                  className={`preview-button ${!image.url ? "disabled" : ""}`}
                  onClick={() => image.url && setPreviewUrl(image.url)}
                  disabled={!image.url}
                >
                  <img
                    src={image.url ? image.url : preview}
                    alt="Preview"
                    className="icon-img"
                    style={{ width: "15px", height: "15px", borderRadius: "2px" }}
                  />
                  <span>Preview</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewUrl && (
        <div className="preview-modal" onClick={() => setPreviewUrl(null)}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "80vh" }} />
            <button className="close-btnn" onClick={() => setPreviewUrl(null)}>❌ Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RepairProcess;